// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import React from 'react'
import DataSelect from './data_select/DataSelect'
import SelectedData from './selected_data/SelectedData'
import Search from '../../shared/search/Search'
import './DataPage.css'
import { useData } from '../../shared/contexts/DataContext'
import { useTableUtils } from '../../shared/contexts/TableUtilsContext'
import { useSelectedData } from '../../shared/contexts/SelectedContext'

// Function based component that displays all the components on the data page
function DataPage() {
    const { tableUtils, setTableUtils } = useTableUtils()
    const { selectedData, updateSelection } = useSelectedData()
    const allData = useData()
    const totalRows = allData.length
  return (
    <>
      <Search
        tour="step-data-search"
        update={(e) => setTableUtils({ ...tableUtils, search: e })}
        initial={tableUtils.search}
        searchText={false}
        totalRows={totalRows}
      />
      <SelectedData
        selectedData={selectedData}
        allData={allData}
        dataType={"main"}
        updateSelection={updateSelection}
        tableUtils={tableUtils} // Pass tableUtils down
        setTableUtils={setTableUtils} // Pass setTableUtils down
      />
      <DataSelect/>
    </>
  )
}

export default DataPage